import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import type { FacilityConfig } from '../../services/missionControl.js';
import { insightsService } from '../../services/insights.js';
import './facility-select.css';

export function FacilitySelectPage(): React.ReactElement {
  const [facilities, setFacilities] = useState<FacilityConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    insightsService
      .getCommercialFacilities()
      .then((data) => {
        if (!cancelled) setFacilities(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load facilities');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="facility-select">
        <p className="facility-select__error">{error}</p>
      </div>
    );
  }

  return (
    <div className="facility-select">
      <div className="facility-select__header">
        <h1 className="facility-select__title">Select a Facility</h1>
        <p className="facility-select__subtitle">Choose a commercial facility to view insights</p>
      </div>

      {loading ? (
        <div className="facility-select__grid">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="facility-select__card facility-select__card--skeleton">
              <div className="facility-select__card-info">
                <p className="facility-select__card-name loading-blur">Facility Name</p>
                <p className="facility-select__card-region loading-blur">City, State</p>
              </div>
            </div>
          ))}
        </div>
      ) : facilities.length === 0 ? (
        <p className="facility-select__empty">No commercial facilities found.</p>
      ) : (
        <div className="facility-select__grid">
          {facilities.map((f) => (
            <Link
              key={f.id}
              to={`/insights/${f.id}`}
              state={{ facility: f }}
              className="facility-select__card"
            >
              <div className="facility-select__card-info">
                <p className="facility-select__card-name">{f.facilityName}</p>
                <p className="facility-select__card-region">
                  <MapPin size={14} />
                  {f.location ?? f.region}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
